import { render, staticRenderFns } from "./market-analysis-locale.page.vue?vue&type=template&id=6621aba2&scoped=true"
import script from "./market-analysis-locale.page.vue?vue&type=script&lang=ts"
export * from "./market-analysis-locale.page.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6621aba2",
  null
  
)

export default component.exports